const config = {
  roenBackendURL: process.env.REACT_APP_ROEN_BACKEND_URL,
  roenFilesURL: process.env.REACT_APP_ROEN_FILES_CDN_URL
};

export default config;
